import { inject, Injectable } from '@angular/core';
import { ImportantNoticeApplicationEnum, type TypePick, type Viewer } from '@reconcept-platform/shared/data-access';
import { WebModalService } from '@reconcept-platform/shared/ui/core/modal';
import { cloneDeep } from 'lodash-es';
import { ImportantNoticeModalComponent } from './important-notice-modal/important-notice-modal.component';

@Injectable({ providedIn: 'root' })
export class ImportantNoticeService {
  private modalService = inject(WebModalService);

  // @ts-expect-error TS2344 type constraint not satisfied
  checkImportantNotice(viewer: TypePick<Viewer, 'importantNotices'>, application: ImportantNoticeApplicationEnum) {
    // @ts-expect-error TS2571 object is of type unknown
    const noticesForApplication = cloneDeep(viewer.importantNotices).filter(
      // @ts-expect-error TS7006 implicit any
      (notice) =>
        notice.application === application || notice.application === ImportantNoticeApplicationEnum.ALL_APPLICATIONS,
    );

    if (noticesForApplication.length > 0) {
      this.modalService.showSimpleModal({
        component: ImportantNoticeModalComponent,
        allowBackgroundClose: false,
        showCloseButton: false,
        data: {
          notices: noticesForApplication,
        },
        hideBackground: true,
      });
    }
  }
}
